import { useEffect, useState } from "react";
import axios from "axios";
import Paginator from "../../components/Paginator";
import Wrapper from "../../components/Wrapper";

const Dailysummaryreport = () => {
  const [dailysummaryreport, setDailysummaryreport] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const [selectedRows, setSelectedRows] = useState([]);

  const [totals, setTotals] = useState({
    deposits: 0,
    payouts: 0,
    ussd_costs: 0,
    split_share: 0,
    gross_gaming_revenue: 0,
    net_gaming_revenue: 0,
    b2b_payout: 0,
  });

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`dailysummaryreport?page=${page}`);
      setDailysummaryreport(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);

  const toggleRow = (row) => {
    let updated;

    if (selectedRows.find((r) => r.id === row.id)) {
      updated = selectedRows.filter((r) => r.id !== row.id);
    } else {
      updated = [...selectedRows, row];
    }

    setSelectedRows(updated);
    calculateTotals(updated);
  };

  const calculateTotals = (rows) => {
    const newTotals = {
      deposits: 0,
      payouts: 0,
      ussd_costs: 0,
      split_share: 0,
      gross_gaming_revenue: 0,
      net_gaming_revenue: 0,
      b2b_payout: 0,
    };

    rows.forEach((r) => {
      newTotals.deposits += Number(r.deposits);
      newTotals.payouts += Number(r.payouts);
      newTotals.ussd_costs += Number(r.ussd_costs);

      if (r.split_paid !== 1) {
        newTotals.split_share += Number(r.split_share);
      }

      newTotals.gross_gaming_revenue += Number(r.gross_gaming_revenue);
      newTotals.net_gaming_revenue += Number(r.net_gaming_revenue);

      if (r.b2b_paid !== 1) {
        newTotals.b2b_payout += Number(r.b2b_payout);
      }
    });

    setTotals(newTotals);
  };

  return (
    <Wrapper pageTitle={"Daily Summary Report"}>
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b bg-gray-50">
                <th className="px-4 py-3">Select</th>
                <th className="px-4 py-3">#Ref</th>
                <th className="px-4 py-3">Report Date</th>
                <th className="px-4 py-3">Deposits</th>
                <th className="px-4 py-3">Payouts</th>
                <th className="px-4 py-3">Ussd Costs</th>
                <th className="px-4 py-3">Split Share</th>
                <th className="px-4 py-3">GGR</th>
                <th className="px-4 py-3">Net GGR</th>
                <th className="px-4 py-3">Percent Earning</th>
                <th className="px-4 py-3">B2B Payout</th>
                <th className="px-4 py-3">B2B Paid</th>
                <th className="px-4 py-3">Split Paid</th>
              </tr>
              <tr className="font-bold bg-gray-100">
                <td></td>
                <td></td>
                <td>Totals</td>

                <td>{totals.deposits}</td>
                <td>{totals.payouts}</td>
                <td>{totals.ussd_costs}</td>
                <td>{totals.split_share}</td>
                <td>{totals.gross_gaming_revenue}</td>
                <td>{totals.net_gaming_revenue}</td>

                <td></td>

                <td>{totals.b2b_payout}</td>

                <td></td>
                <td></td>
              </tr>
            </thead>

            <tbody className="bg-white divide-y">
              {dailysummaryreport.map((row) => {
                return (
                  <tr key={row.id} className="text-gray-700">
                    <td className="px-4 py-3">
                      <input
                        type="checkbox"
                        checked={selectedRows.some((r) => r.id === row.id)}
                        onChange={() => toggleRow(row)}
                      />
                    </td>

                    <td className="px-4 py-3">{row.id}</td>

                    <td className="px-4 py-3">{row.report_date}</td>

                    <td className="px-4 py-3">{row.deposits}</td>

                    <td className="px-4 py-3">{row.payouts}</td>

                    <td className="px-4 py-3">{row.ussd_costs}</td>

                    <td className="px-4 py-3">{row.split_share}</td>

                    <td className="px-4 py-3">{row.gross_gaming_revenue}</td>

                    <td className="px-4 py-3">{row.net_gaming_revenue}</td>

                    <td className="px-4 py-3">{row.perc_earning}</td>

                    <td className="px-4 py-3">{row.b2b_payout}</td>

                    <td className="px-4 py-3">{row.b2b_paid}</td>

                    <td className="px-4 py-3">{row.split_paid}</td>
                  </tr>
                );
              })}
            </tbody>

            <tfoot>
              <tr className="font-bold bg-gray-100">
                <td></td>
                <td></td>
                <td>Totals</td>

                <td>{totals.deposits}</td>
                <td>{totals.payouts}</td>
                <td>{totals.ussd_costs}</td>
                <td>{totals.split_share}</td>
                <td>{totals.gross_gaming_revenue}</td>
                <td>{totals.net_gaming_revenue}</td>

                <td></td>

                <td>{totals.b2b_payout}</td>

                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};

export default Dailysummaryreport;
